import { BookingsBOLink } from '@wix/bookings-catalog-calendar-viewer-utils';

const bookingsPrefix = 'bookings';

enum BackofficePanelUrls {
  ADD_NEW_SERVICE = `${bookingsPrefix}/${BookingsBOLink.ADD_NEW_SERVICE}`,
  SERVICES = `${bookingsPrefix}/${BookingsBOLink.SERVICES}?origin=editor3_my_bookings_manage_bookings`,
  CALENDAR = `${bookingsPrefix}/${BookingsBOLink.CALENDAR}?origin=editor3_my_bookings_manage_sessions`,
  FORM_FIELD_SETTINGS = `${bookingsPrefix}/form-composer/00000000-0000-0000-0000-000000000000/edit?enableConfigOverride=&referral=manage-forms`,
  AVAILABILITY = `${bookingsPrefix}/${BookingsBOLink.AVAILABILITY}?origin=editor3_my_bookings_manage_availability`,
  SETTINGS = `${bookingsPrefix}/${BookingsBOLink.SETTINGS}?origin=editor3_my_bookings_manage_bookings_settings`,
  SHARABLE_LINKS = `${bookingsPrefix}/${BookingsBOLink.SHARABLE_LINKS}?origin=editor3_my_bookings_manage_sharable_links`,
  INTEGRATIONS = `${bookingsPrefix}/${BookingsBOLink.INTEGRATIONS}?origin=editor3_my_bookings_manage_integrations`,
  BOOK_FLOW_CUSTOMIZE = `${bookingsPrefix}/${BookingsBOLink.BOOK_FLOW_CUSTOMIZE}?origin=editor3_my_bookings_manage_client_flow`,
}

async function openDashboardPanelWithUrl(editorSDK, appToken, url) {
  await editorSDK.editor.openDashboardPanel(appToken, {
    url,
    closeOtherPanels: false,
  });
}

export async function openBookingsDashboardAddNewService(
  editorSdkAdapter,
  editorSDK,
  appToken,
) {
  await openDashboardPanelWithUrl(
    editorSDK,
    appToken,
    BackofficePanelUrls.ADD_NEW_SERVICE,
  );
  editorSdkAdapter.refreshApp('MANAGE_BOOKINGS_CLOSE', true);
}

export async function openManageBookings(
  editorSdkAdapter,
  editorSDK,
  appToken,
) {
  await openDashboardPanelWithUrl(
    editorSDK,
    appToken,
    BackofficePanelUrls.SERVICES,
  );
  editorSdkAdapter.refreshApp('MANAGE_BOOKINGS_CLOSE', true);
}

export async function openBackOfficeCalendar(editorSDK, appToken) {
  await openDashboardPanelWithUrl(
    editorSDK,
    appToken,
    BackofficePanelUrls.CALENDAR,
  );
}

export async function openFormFieldSettingsPanel(editorSDK, appToken) {
  await openDashboardPanelWithUrl(
    editorSDK,
    appToken,
    BackofficePanelUrls.FORM_FIELD_SETTINGS,
  );
}

export const openBookingsAvailability = async (editorSDK, appToken) => {
  await openDashboardPanelWithUrl(
    editorSDK,
    appToken,
    BackofficePanelUrls.AVAILABILITY,
  );
};

export const openBookingsSettings = async (editorSDK, appToken) => {
  await openDashboardPanelWithUrl(
    editorSDK,
    appToken,
    BackofficePanelUrls.SETTINGS,
  );
};

export const openSharableLinks = async (editorSDK, appToken) => {
  await openDashboardPanelWithUrl(
    editorSDK,
    appToken,
    BackofficePanelUrls.SHARABLE_LINKS,
  );
};

export const openIntegrations = async (editorSDK, appToken) => {
  await openDashboardPanelWithUrl(
    editorSDK,
    appToken,
    BackofficePanelUrls.INTEGRATIONS,
  );
};

export const openManageClientFlow = async (editorSDK, appToken) => {
  await openDashboardPanelWithUrl(
    editorSDK,
    appToken,
    BackofficePanelUrls.BOOK_FLOW_CUSTOMIZE,
  );
};
